import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

import { EngringJobsComp } from "../../components/allPostjobs";
import { AppDispatch, RootState } from "../../store";
import {
  decreasePage,
  getAllPostJobs,
  increasePage,
  jobsPerPage,
} from "../../features/postJob/getAllPostJobsSlice";
import { Pagination } from "../../components/General/helpers";
import { addQueryParams } from "../../utils/queryParams";
import { createSaveLaterAction } from "../../features/saveForLater/createSaveLateSlice";
import Loader from "../../components/General/Loader";
import Overlay from "../../components/General/overlay";
import {
  setCloseConfirmationModal,
  setOpenConfirmationModal,
  setPostJobId,
} from "../../features/general/generalSlice";
import StatCardSkeleton from "../../components/Skeletons/StatCardSkeleton";

const EngineeringJobs = () => {
  const {
    engineeringPostJobs,
    totalPages,
    currentPage,
    pageSize,
    postJobsLoading,
  } = useSelector((store: RootState) => store.allPostJobsStore);

  const { isCreateSaveForLaterLoading } = useSelector(
    (store: RootState) => store.createSaveForLaterStore
  );
  const { postJobId } = useSelector((store: RootState) => store.generalStore);

  const [isJobPage, setIsJobPage] = useState(false);

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Initial save for later modal
  const initialSaveForLater = (index: string) => {
    dispatch(setPostJobId(index));
    dispatch(setOpenConfirmationModal());
  };

  // Save job for later
  const handleSaveForLater = () => {
    dispatch(setCloseConfirmationModal());

    const objectToSave = engineeringPostJobs?.find(
      (each: any) => each._id === postJobId
    );
    // Save for later if only not in save-for-later page
    if (!pathname.includes("save-for-later")) {
      dispatch(createSaveLaterAction(objectToSave));
    }
  };

  // Show job details
  const handleJobDetails = (index: string) => {
    navigate(`/dashboard/all-post-jobs/${index}`);
  };

  // Go to next page
  const handleNextButton = () => {
    dispatch(increasePage());
  };

  // Go to previous page
  const handlePreviousButton = () => {
    dispatch(decreasePage());
  };

  // Set the number of jobs to see per page
  const handleClickPage = (value: number) => {
    // console.log(value);
    dispatch(jobsPerPage(value));
    setIsJobPage(false);
  };

  // INCLUDE THE URL WITH THE LIMIT AND PAGE NUMBERS
  useEffect(() => {
    addQueryParams(pathname, currentPage, pageSize);
  }, [pathname, currentPage, pageSize]);

  useEffect(() => {
    dispatch(getAllPostJobs({ isEngineering: true, currentPage, pageSize }));
  }, [currentPage, pageSize, dispatch]);

  if (postJobsLoading) {
    return <StatCardSkeleton />;
  }

  if (engineeringPostJobs.length < 1) {
    return (
      <NoJobsWrapper>
        <p className="no__job">NO ENGINEERING JOBS FOR THIS PAGE</p>
      </NoJobsWrapper>
    );
  }

  return (
    <>
      {isCreateSaveForLaterLoading && (
        <Overlay>
          <Loader loaderStyle={""} />
        </Overlay>
      )}
      <EngringJobsComp
        handleJobDetails={handleJobDetails}
        initialSaveForLater={initialSaveForLater}
        handleSaveForLater={handleSaveForLater}
      />
      <Pagination
        handlePreviousButton={handlePreviousButton}
        handleNextButton={handleNextButton}
        handleClickPage={handleClickPage}
        isJobPage={isJobPage}
        setIsJobPage={setIsJobPage}
        totalPages={totalPages}
        currentPage={currentPage}
        pageSize={pageSize}
      />
    </>
  );
};

export default EngineeringJobs;

const NoJobsWrapper = styled.div`
  .no__job {
    font-size: 24px;
    font-weight: bold;
  }
  @media screen and (max-width: 540px) {
    .no__job {
      font-size: 18px;
    }
  }
`;
